import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { AddPrinterParams, Printer, PrinterTypesResponse } from './printers.model';
import { GenericApiResponse } from '../general-store/general.model';

interface PrintersResponse extends GenericApiResponse {
  payload: Printer[];
}

interface PrinterTypesApiResponse extends GenericApiResponse {
  payload: PrinterTypesResponse;
}

@Injectable({ providedIn: 'root' })
export class PrintersService {
  private readonly apiUrl = environment.apiUrl + '/api/printers/';

  private readonly http = inject(HttpClient);

  listPrinters(): Observable<PrintersResponse> {
    return this.http.get<PrintersResponse>(this.apiUrl);
  }

  getPrinterTypes(): Observable<PrinterTypesApiResponse> {
    return this.http.get<PrinterTypesApiResponse>(environment.apiUrl + '/api/data/printer-types');
  }

  addPrinter(printer: AddPrinterParams): Observable<Printer> {
    return this.http.post<Printer>(this.apiUrl, printer);
  }

  updatePrinter(id: number, printer: AddPrinterParams): Observable<Printer> {
    return this.http.put<Printer>(this.apiUrl + id, printer);
  }

  deletePrinter(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(this.apiUrl + id);
  }
}
